import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Users, Check, X, Shield, User as UserIcon, Edit as EditIcon } from 'lucide-react';
import './UserManagement.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

const authHeaders = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
});

const UserManagement = ({ user, onBack }) => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadUsers();
  }, []);

  const loadUsers = async () => {
    try {
      const response = await axios.get(`${API_URL}/admin/users`, authHeaders());
      setUsers(response.data);
    } catch (error) {
      console.error('Erro ao carregar usuários:', error);
      alert('Erro ao carregar usuários');
    } finally {
      setLoading(false);
    }
  };

  const handleApprove = async (userId) => {
    try {
      await axios.put(`${API_URL}/admin/users/${userId}/approve`, {}, authHeaders());
      loadUsers();
    } catch (error) {
      console.error('Erro ao aprovar usuário:', error);
      alert('Erro ao aprovar usuário');
    }
  };

  const handleReject = async (userId) => {
    if (!window.confirm('Tem certeza que deseja rejeitar este usuário?')) return;
    try {
      await axios.put(`${API_URL}/admin/users/${userId}/reject`, {}, authHeaders());
      loadUsers();
    } catch (error) {
      console.error('Erro ao rejeitar usuário:', error);
      alert('Erro ao rejeitar usuário');
    }
  };

  const handleToggleRole = async (userId, currentRole) => {
    // Ciclo: user → editor → admin → user
    const roleMap = { user: 'editor', editor: 'admin', admin: 'user' };
    const newRole = roleMap[currentRole] || 'user';
    const roleLabels = { user: 'Usuário', editor: 'Editor', admin: 'Administrador' };
    console.log('handleToggleRole — userId:', userId, '| currentRole:', JSON.stringify(currentRole), '| newRole:', JSON.stringify(newRole));
    if (!window.confirm(`Alterar role para "${roleLabels[newRole] || newRole}"?`)) return;
    try {
      await axios.put(`${API_URL}/admin/users/${userId}/role`, { role: newRole }, authHeaders());
      loadUsers();
    } catch (error) {
      const status = error.response?.status;
      const msg = error.response?.data?.error || error.message;
      console.error('Erro ao alterar role:', status, msg, error);
      alert(`Erro ao alterar role\nStatus: ${status}\nDetalhe: ${msg}`);
    }
  };

  const getStatusBadge = (status) => {
    switch (status) {
      case 'aprovado':
        return <span className="status-badge status-approved">Aprovado</span>;
      case 'pendente':
        return <span className="status-badge status-pending">Pendente</span>;
      case 'rejeitado':
        return <span className="status-badge status-rejected">Rejeitado</span>;
      default:
        return <span className="status-badge">{status}</span>;
    }
  };

  if (loading) {
    return <div className="loading">Carregando...</div>;
  }

  return (
    <div className="user-management">
      <div className="user-management-header">
        <div>
          <h2>
            <Users size={24} />
            Gerenciamento de Usuários
          </h2>
          <p>Aprove ou rejeite solicitações de cadastro</p>
        </div>
        <button className="btn-secondary" onClick={onBack}>
          Voltar
        </button>
      </div>

      <div className="users-table-container">
        <table className="users-table">
          <thead>
            <tr>
              <th>Nome</th>
              <th>Email</th>
              <th>Role</th>
              <th>Status</th>
              <th>Data Cadastro</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.id}>
                <td>{u.nome}</td>
                <td>{u.email}</td>
                <td>
                  <button
                    className={`role-badge ${u.role}`}
                    onClick={() => handleToggleRole(u.id, u.role)}
                    title="Clique para alterar role (user → editor → admin)"
                  >
                    {u.role === 'admin' && <Shield size={14} />}
                    {u.role === 'editor' && <EditIcon size={14} />}
                    {u.role === 'user' && <UserIcon size={14} />}
                    {u.role}
                  </button>
                </td>
                <td>{getStatusBadge(u.status)}</td>
                <td>{new Date(u.data_cadastro).toLocaleDateString('pt-BR')}</td>
                <td>
                  {u.status === 'pendente' && (
                    <>
                      <button
                        className="btn-approve"
                        onClick={() => handleApprove(u.id)}
                        title="Aprovar"
                      >
                        <Check size={16} />
                      </button>
                      <button
                        className="btn-reject"
                        onClick={() => handleReject(u.id)}
                        title="Rejeitar"
                      >
                        <X size={16} />
                      </button>
                    </>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default UserManagement;
